import React, { useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import ButtonTable from "../../common/table/buttonTable";
import DateFormat from "../../common/dateFormat/DateFormat";
import { ModalAlert } from "../../common/dialog/modalAlert";
import { buscarPdf } from "../../demandaContrato/demandaContratoActions";
import { setArquivoPDF } from "../../displayPDF/displayPDFActions";
import Row from "../../common/layout/row";
import Select from "../../common/form/select";

function ModalHistoricoDemandasComponent(props) {
    const [filtro, setFiltro] = useState({
        descricao: null,
    });
    if (!props.visible) return null;
    const set = new Set(
        props.contratoDemanda.historico.map((h) => {
            if (h.descricao.includes("horário ponta diferenciado")) {
                return "Horário Ponta Diferenciado";
            }
            if (h.descricao.includes("período de teste")) {
                return "Período de Teste";
            }
            if (h.descricao.includes("tarefa do tipo")) {
                return "Tarefa";
            }
            if (h.descricao.includes("tabela de valores")) {
                return "Tabela de Valores";
            }
            if (h.descricao.includes("Alterações:")) {
                return "Alterações";
            }
            if (h.descricao.includes("agendamento")) {
                return "Agendamento";
            }
            return h.descricao;
        })
    );

    function filtrarPelaDescricao(item) {
        return !filtro.descricao || String(item.descricao).toLowerCase().includes(String(filtro.descricao).toLowerCase());
    }

    const descricoesUnicas = [...set].map((item) => ({ id: item, valor: item }));
    return (
        <ModalAlert
            titulo="Histórico dos Contratos de Demanda"
            handleClose={() => {
                setFiltro({ ...props.filtro, descricao: null });
                props.handleClose();
            }}
        >
            <Row>
                <Select
                    options={descricoesUnicas}
                    label="Filtrar por Assunto"
                    cols="12 12 12 12"
                    placeholder="Selecione o assunto"
                    value={filtro.descricao}
                    onChange={(value) => {
                        setFiltro({ ...props.filtro, descricao: value });
                    }}
                />
            </Row>
            <div className="custom-scroll" style={{ maxHeight: 400, overflowY: "auto" }}>
                <table style={{ borderCollapse: "collapse", width: "100%" }}>
                    <thead>
                        <tr
                            style={{
                                position: "sticky",
                                zIndex: 1,
                                backgroundColor: "#586269",
                                color: "#FFF",
                                height: 40,
                                top: 0,
                            }}
                        >
                            <th style={{ paddingInline: 50 }}>Descrição</th>
                            <th style={{ textAlign: "center" }}>Nº da Tarefa</th>
                            <th style={{ textAlign: "center", width: "fit-content" }}>Status da Tarefa</th>
                            <th style={{ textAlign: "center" }}>Data/Hora</th>
                            <th style={{ textAlign: "center" }}>Usuário</th>
                            <th style={{ textAlign: "center" }}>Contrato CUSD</th>
                            <th style={{ textAlign: "center" }}>Contrato Horário Ponta Diferenciado</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.contratoDemanda.historico.filter(filtrarPelaDescricao).map((h) => {
                            const coresStatus = {
                                Iniciada: "#009dff",
                                Excluída: "#ff174a",
                                Finalizada: "#00c864",
                                "Em andamento": "#f3ac49",
                            };

                            return (
                                <tr key={h.id} style={{ borderBlock: "1px solid #ccc", paddingTop: 30 }}>
                                    <td style={{ paddingInline: 50 }}>{h.descricao}</td>
                                    <td style={{ textAlign: "center" }}>{h.sequencia_ano || " - "}</td>
                                    <td style={{ textAlign: "center" }}>
                                        {h.status ? (
                                            <div style={{ color: "#FFF", minWidth: 110, borderRadius: "0.2rem", padding: 4, backgroundColor: coresStatus[h.status] }}>
                                                {h.status}{" "}
                                            </div>
                                        ) : (
                                            " - "
                                        )}
                                    </td>
                                    <td style={{ textAlign: "center" }}>{DateFormat.formatarDataHoraSqlParaTela(h.datahora_inclusao)}</td>
                                    <td style={{ textAlign: "center" }}>{h.nome_usuario}</td>
                                    <td style={{ verticalAlign: "top" }}>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: h.arquivo_cusd ? "start" : "center",
                                                alignItems: "center",
                                                minHeight: 40,
                                            }}
                                        >
                                            {h.arquivo_cusd ? (
                                                <ButtonTable
                                                    style={{ margin: 0 }}
                                                    title="Visualizar PDF"
                                                    type={"primary"}
                                                    icon={"fas fa-file-pdf"}
                                                    disabled={!h.arquivo_cusd}
                                                    visible={true}
                                                    event={() => {
                                                        props.buscarPdf(h.id);
                                                        props.setArquivoPDF();
                                                    }}
                                                />
                                            ) : (
                                                <div>-</div>
                                            )}
                                        </div>
                                    </td>
                                    <td style={{ verticalAlign: "top" }}>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: h.arquivo_contrato_horario ? "start" : "center",
                                                alignItems: "center",
                                                minHeight: 40,
                                            }}
                                        >
                                            {h.arquivo_contrato_horario ? (
                                                <ButtonTable
                                                    style={{ margin: 0 }}
                                                    title="Visualizar PDF"
                                                    type={"primary"}
                                                    icon={"fas fa-file-pdf"}
                                                    disabled={!h.arquivo_contrato_horario}
                                                    visible={true}
                                                    event={() => {
                                                        props.buscarPdf(h.id);
                                                        props.setArquivoPDF();
                                                    }}
                                                />
                                            ) : (
                                                <div>-</div>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </ModalAlert>
    );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            buscarPdf,
            setArquivoPDF,
        },
        dispatch
    );
const ModalHistoricoDemandas = connect(mapStateToProps, mapDispatchToProps)(ModalHistoricoDemandasComponent);

export { ModalHistoricoDemandas };
